import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home.vue"
import Locations from "./views/Locations.vue"
import LocationDetail from "./views/LocationDetail.vue"
import LotsDetail from "./views/LotsDetail"
import ComputerAssets from "./views/ComputerAssets.vue"
import monitorAssets from "./views/MonitorAssets.vue"
import phoneAssets from "./views/PhoneAssets.vue"
import AssetDetail from "./views/AssetDetail.vue"
import Login from "./views/Login.vue"
import Label from "./views/Label.vue"
import Recycle from "./views/Recycle.vue"
import Settings from "./views/Settings.vue"
import Lots from "./views/Lots.vue"
import Setup from "./views/Setup.vue"
import Download from "./views/Download.vue"
import PageNotFound from "./views/404.vue"
import Inventory from "./views/Inventory.vue"
import Client from "./views/Clients.vue"
import PublicAssetDetail from "./views/PublicAssetDetail"
const fb = require("./firebaseConfig.js")

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: "/location",
      name: "Location",
      component: Locations,
      meta: { requiresAuth: true }
    },
    {
      path: "/lots",
      name: "Lots",
      component: Lots,
      meta: { requiresAuth: true }
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: { requiresAuth: true }
    },
    {
      path: "/inventory",
      name: "inventory",
      component: Inventory,
      meta: { requiresAuth: true }
    },
    {
      path: "/createLabel",
      name: "create Label",
      component: Label,
      meta: { requiresAuth: true }
    },
    { path: "/", name: "Signin", component: Login },
    {
      path: "/computerAssets",
      name: "ComputerAssets",
      component: ComputerAssets,
      meta: { requiresAuth: true }
    },
    {
      path: "/phoneAssets",
      name: "PhoneAssets",
      component: phoneAssets,
      meta: { requiresAuth: true }
    },
    {
      path: "/monitorAssets",
      name: "MonitorAssets",
      component: monitorAssets,
      meta: { requiresAuth: true }
    },
    {
      path: "/location/:name",
      name: "location with id",
      component: LocationDetail,
      meta: { requiresAuth: true }
    },
    {
      path: "/lots/:name",
      name: "lots with id",
      component: LotsDetail,
      meta: { requiresAuth: true }
    },
    {
      path: "/assets/:id",
      name: "Assets with id",
      component: AssetDetail,
      meta: { requiresAuth: true }
    },
    {
      path: "/recycle",
      name: "Recycle",
      component: Recycle,
      meta: { requiresAuth: true }
    },
    {
      path: "/setup",
      name: "Setup",
      component: Setup,
      meta: { requiresAuth: true }
    },
    {
      path: "/download",
      name: "Download",
      component: Download,
      meta: { requiresAuth: true }
    },
    {
      path: "/clients",
      name: "Client",
      component: Client,
      meta: { requiresAuth: true }
    },
    {
      path: "/public/assets/:id",
      name: "Public Assets with id",
      component: PublicAssetDetail,
      meta: { requiresAuth: false }
    },
    { path: "*", component: PageNotFound }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    fb.auth.onAuthStateChanged(user => {
      if (!user) {
        next({
          path: "/"
        })
      } else {
        next()
      }
    })
    // this route requires auth, check if logged in
    // if not, redirect to login page.
  } else {
    next() // make sure to always call next()!
  }
})

export default router
